import './allur-loader.scss';

import { useEffect, useRef } from 'react';

import svgContent from './allur-finance-animated.svg?raw';

export interface IProps {
  blurMode?: boolean;
  fullScreen?: boolean;
  fullWidth?: boolean;
  layout?: boolean;
  text?: string;
}

const AllurLoader: React.FC<IProps> = ({
  blurMode,
  fullScreen,
  fullWidth,
  layout,
  text
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const host = containerRef.current;
    if (!host) return;

    let shadowRoot = host.shadowRoot;
    if (!shadowRoot) {
      shadowRoot = host.attachShadow({ mode: 'open' });
    } else {
      while (shadowRoot.firstChild) {
        shadowRoot.removeChild(shadowRoot.firstChild);
      }
    }

    const svgContainer = document.createElement('div');
    svgContainer.className = 'allur-loader__logo';
    svgContainer.innerHTML = svgContent;
    shadowRoot.appendChild(svgContainer);

    if (text) {
      const textElement = document.createElement('p');
      textElement.textContent = text;
      textElement.style.cssText = `
        color: #fff;
        font-size: 16px;
        font-weight: 600;
        margin: 0;
        max-width: 400px;
        padding: 0 48px;
        text-align: center;
      `;
      shadowRoot.appendChild(textElement);
    }

    const style = document.createElement('style');
    style.textContent = `
      .allur-loader__logo {
        width: 120px;
        filter: drop-shadow(-1px -1px rgba(155, 28, 19, 0.1));
      }
      .allur-loader__logo svg {
        display: block;
        width: 100%;
        height: 100%;
      }
    `;
    shadowRoot.appendChild(style);

    return () => {
      const shadow = host.shadowRoot;
      if (!shadow) return;
      while (shadow.firstChild) {
        shadow.removeChild(shadow.firstChild);
      }
    };
  }, [text]);

  useEffect(() => {
    if (!fullScreen && !layout) return;

    const handleTabKey = (e: KeyboardEvent) => {
      if (e.key === 'Tab') {
        e.preventDefault();
      }
    };
    document.addEventListener('keydown', handleTabKey);
    return () => document.removeEventListener('keydown', handleTabKey);
  }, [fullScreen, layout]);

  const rootClasses = [
    'allur-loader',
    fullWidth ? 'allur-loader--full-width' : '',
    fullScreen ? 'allur-loader--fullscreen' : '',
    blurMode ? 'allur-loader--blur-mode' : '',
    layout ? 'allur-loader--layout' : ''
  ].join(' ');

  return <div ref={containerRef} className={rootClasses} />;
};

export default AllurLoader;
